const lang = {
    action: {
        language: 'id',
        finishing: 'Menyelesaikan',
        only_admin: 'Hanya akun pemilik epustaka yang dapat melakukan ubah',
        add_filter: 'Tambahkan filter',
        add: 'Tambahkan',
        addEvent: 'Tambah Jadwal',
        addLevel: 'Tambah Tingkatan Kesulitan',
        addQuizCategories: 'Tambah Kategori Quiz',
        back: 'Kembali',
        bulk_actions: '{{smart_count}} terpilih',
        cancel: 'Batal',
        clear_input_value: 'Kosongkan input',
        clone: 'Duplikat',
        confirm: 'Konfirmasi',
        create: 'Buat',
        find: 'Cari',
        delete: 'Hapus',
        edit: 'Ubah',
        export: 'Ekspor',
        list: 'Daftar',
        refresh: 'Perbaharui',
        remove_filter: 'Hapus filter',
        remove: 'Hapus',
        save: 'Simpan',
        search: 'Mencari',
        show: 'Tampilkan',
        sort: 'Pengurutan',
        undo: 'Batalkan',
        viewDetail: 'Lihat Detail',
        bulkInsertStudent: 'Bulk Insert Siswa',
        bulkInsertTeacher: 'Bulk Insert Guru',
        promoteGradeStudent: 'Naik / Pindah Kelas',
        finish: 'Selesai',
        preview: 'Lihat',
        addAssigment: 'Tambah Tugas',
        confirmAddAdmin: 'Anda yakin akan menambahkan sebagai admin sekolah?',
        confirmMigration: 'Mutasi data pengguna ke sekolah anda?',
        verification: 'Verifikasi',
    },
    boolean: {
        true: 'Ya',
        false: 'Tidak',
        aktif: 'Aktif',
        tidakAktif: 'Tidak Aktif',
        banner: {
            internal: 'Konten Internal',
            website: 'Website',
        },
        epustaka: {
            private: 'Epustaka Pribadi',
            public: 'Epustaka Publik',
            perorangan: 'Perorangan',
            lembaga: 'Lembaga',
        },
        book: {
            private: 'Buku Pribadi',
            public: 'Buku Publik',
        },
    },
    page: {
        create: 'Buat {{name}}',
        dashboard: 'Dasbor',
        edit: '{{name}} #{{id}}',
        error: 'Ada yang salah',
        list: '{{name}}',
        loading: 'Pemuatan',
        landing: 'Halaman Depan / Utama',
        landinginfo: 'Contoh Halaman Depan',
        not_found: 'Tidak ditemukan',
        show: '{{name}} #{{id}}',
        page1: 'Halaman 1',
        page2: 'Halaman 2',
    },
    input: {
        bulk: {
            student: 'Upload data XLSX siswa',
            teacher: 'Upload data XLSX guru',
        },
        file: {
            upload_several:
                'Letakan beberapa file untuk diunggah, atau klik untuk memilihnya.',
            upload_single:
                'Letakan file yang akan diunggah, atau klik untuk memilihnya.',
        },
        image: {
            upload_several:
                'Letakan beberapa gambar untuk diunggah, atau klik untuk memilihnya.',
            upload_single:
                'Letakan gambar untuk diunggah, atau klik untuk memilihnya.',
        },
        references: {
            all_missing: 'Tidak dapat menemukan data referensi.',
            many_missing:
                'Setidaknya satu referensi terkait tidak lagi tersedia.',
            single_missing: 'Referensi terkait tidak lagi tersedia.',
        },
        addAcount: 'Pilih Akun',
        addAccountTitle: 'Tambah Admin Sekolah',
        addAcountPlaceholder: 'Pilih akun untuk dijadikan admin sekolah',
        MigrationUserPlaceholder: 'Pilih akun untuk dimutasi',
    },
    message: {
        about: 'Tentang',
        are_you_sure: 'Apakah anda yakin?',
        bulk_delete_content:
            'Anda yakin ingin menghapus {{name}}? |||| Anda yakin ingin menghapus {{smart_count}} items ini?',
        bulk_delete_title:
            'Hapus {{name}} |||| Hapus {{smart_count}} {{name}} items',
        delete_content: 'Anda yakin ingin menghapus item ini?',
        delete_title: 'Konfirmasi Hapus',
        details: 'Detail',
        error:
            'Terjadi kesalahan pada klien dan permintaan Anda tidak dapat diselesaikan.',
        invalid_form:
            'Formulir tidak valid, ada kesalahan. Silakan periksa kembali',
        loading: 'Halaman ini sedang memuat, silahkan tunggu sebentar',
        no: 'Tidak',
        not_found:
            'Entah Anda mengetikkan URL yang salah, atau Anda memiliki link yang salah.',
        yes: 'Ya',
        verification_success: 'Verifikasi Berhasil',
        successAddADmin: 'Data admin sekolah ditambahkan',
        successRemoveADmin: 'Data admin sekolah dihapus',
        successMigration: 'Mutasi data user berhasil',
        hour: 'Jam',
        minute: 'Menit',
    },
    navigation: {
        no_results: 'Tidak ada hasil yang ditemukan',
        no_more_results: 'Halaman {{page}} tidak ada. Coba halaman sebelumnya.',
        page_out_of_boundaries: 'Halaman {{page}} tidak ada',
        page_out_from_end: 'Halaman terakhir',
        page_out_from_begin: 'Halaman harus lebih besar dari pertama',
        page_range_info: '{{offsetBegin}}-{{offsetEnd}} dari {{total}}',
        page_rows_per_page: 'Baris per halaman:',
        next: 'Berikutnya',
        prev: 'Sebelumnya',
        fillAnswerForm: 'Isi form jawaban',
        fillQuestionForm: 'Isi form soal',
    },
    auth: {
        user_menu: 'Profil',
        username: 'Nama pengguna',
        password: 'Kata sandi',
        sign_in: 'Masuk',
        sign_in_error: 'Otentikasi gagal, coba lagi',
        logout: 'Keluar',
        lock: 'Kunci Akun',
        setting: 'Pengaturan',
        profile: 'Profil',
        account: 'Akun',
    },
    notification: {
        updated:
            'Elemen telah diperbaharui |||| {{smart_count}} elemen telah diperbaharui',
        created: 'Elemen telah dibuat',
        dataCreated: 'Data telah dibuat',
        deleted: {
            single: 'Elemen telah dihapus',
            multiple: '{{smart_count}} elemen telah dihapus',
        },
        bad_item: 'Elemen salah',
        item_doesnt_exist: 'Elemen tidak ada',
        http_error: 'Kesalahan komunikasi peladen',
        data_provider_error:
            'kesalahan pada dataProvider. Periksa konsol untuk detailnya.',
        canceled: 'Telah dibatalkan',
        logged_out: 'Sesi Anda telah berakhir, harap sambungkan kembali.',
    },
    validation: {
        required: 'Wajib diisi.',
        minLength: 'Minimal {{min}} karakter',
        maxLength: 'Maksimal {{max}} karakter atau kurang',
        maxImage: 'Gambar harus lebih kecil dari 2MB!',
        maxAudio: 'Audio harus lebih kecil dari 50MB!',
        maxVideo: 'Video harus lebih kecil dari 250MB!',
        minValue: 'Minimal {{min}}',
        maxValue: 'Maksimal {{max}} atau kurang',
        number: 'Harus Angka',
        email: 'Harus alamat email yang valid',
        emailExist: 'Email telah digunakan',
        emailBulkExist: 'Terdapat email yang sudah digunakan dalam data bulk',
        oneOf: 'Harus salah satu dari : {{options}}',
        regex: 'Harus sesuai dengan format tertentu (regexp): {{pattern}}',
        cantPastCurrentYear: 'Tidak dapat melebihi tahun saat ini.',
        cantBeSmallerThanYearStart: 'Tidak dapat lebih kecil dari tahun awal',
        dataExist: 'Data sudah ada',
        gradeNotExist:
            'Data Kelas Kosong, Harap Isi Terlebih Dahulu Data Kelas',
        dataBulkNotValid:
            'Terdapat data yang tidak valid / file tidak menggunakan format yang ditentukan.',
        dataEmpty: 'Data tidak valid atau kosong',
    },
    menu: {
        menuUtama: 'Menu Utama',
        halamanUtama: 'Halaman Utama',
        content: 'Konten',
        school: 'Sekolah',
        exam: 'Ujian',
        config: 'Konfigurasi',
        onlineTraining: 'Pelatihan Online',
        edoo: 'Edoo Administrator',
        jadwal: 'Jadwal Mata Pelajaran',
        jadwalPelatihan: 'Jadwal Pelatihan',
        pendaftar: 'Pendaftar',
        event: 'Event Sekolah',
        absensi: 'Kehadiran Siswa',
        aktiPustaka: 'Aktivitas Epustaka',
        aktiDonasi: 'Aktivitas Donasi',
        aktiAdmin: 'Aktivitas Admin',
        ruangan: 'Ruangan',
        bankSoal: 'Bank Soal',
        migrasi: 'Mutasi (Guru/Siswa)',
        examPackage: 'Paket Ujian',
        stats: {
            siswaHadir: 'Siswa Hadir Hari Ini',
            userAktif: 'Pengguna Aktif Hari Ini',
            peminjaman: 'Peminjaman Hari Ini',
        },
        admin: {
            buku: 'Buku',
            video: 'Video',
            audio: 'Audio',
            multimediaCategory: 'Kategori Multimedia',
            tahunAjaran: 'Tahun Ajaran',
            jurusan: 'Jurusan Sekolah',
            kelas: 'Kelas',
            subKelas: 'Sub-Kelas',
            pelajaran: 'Mata Pelajaran',
            akademik: 'Akademik',
            daftarSiswa: 'Daftar Siswa',
            daftarGuru: 'Daftar Guru',
            userMigrate: 'Mutasi (Guru/Siswa)',
            settingAdminSekolah: 'Setting Admin Sekolah',
            kalender: 'Kalender Akademik',
            banner: 'Banner',
            pengajar: 'Pengajar',
            ujian: {
                KategoriQuiz: 'Kategori Quiz',
                configQuiz: 'Konfigurasi Quiz',
                questionLevel: 'Tingkat Kesulitan Soal',
            },
            donation: 'Donasi',
        },
        superAdmin: {
            daftarSekolah: 'Daftar Sekolah',
        },
        guru: {
            tugas: 'Tugas',
            nilai: 'Nilai',
            bukuAjar: 'Buku Ajar',
            jadwal: 'Jadwal Mengajar',
            event: 'Kegiatan',
        },
    },
    column: {
        aksi: 'Aksi',
        namaGuru: 'Nama Guru',
        namaSiswa: 'Nama Siswa',
        tahunAjaran: {
            tahunAjaran: 'Tahun Ajaran',
            semester: 'Semester',
            status: 'Status',
        },
        jurusan: {
            namaJurusan: 'Nama Jurusan',
            deskripsi: 'Deskripsi',
        },
        ruangan: {
            namaRuangan: 'Nama Ruangan',
            deskripsi: 'Deskripsi',
        },
        kelas: {
            namaKelas: 'Nama Kelas',
            deskripsi: 'Deskripsi',
            classScope: 'Cakupan Kelas',
            internalSekolah: 'Internal Sekolah',
            public: 'Publik'
        },
        pelajaran: {
            mataPelajaran: 'Mata Pelajaran',
            subjectPrice: 'Harga'
        },
        user: {
            nama: 'Nama',
            customNama: 'Nama {{role}}',
            email: 'Email',
            telepon: 'Telepon',
            kota: 'Kota/Kabupaten',
            alamat: 'Alamat',
            nis: 'NIS',
            nik: 'NIK',
            bio: 'Biografi',
            avatar: 'Foto Profil',
            StatusPengguna: 'Status Pengguna',
            guest: 'Guest',
            admin: 'Admin Sekolah',
            teacher: 'Guru',
            student: 'Siswa',
        },
        jadwal: {
            tanggal: 'Tanggal',
            waktuMulai: 'Waktu Mulai',
            waktuSelesai: 'Waktu Selesai',
            waktu: 'Waktu',
        },
        event: {
            event_name: 'Nama Kegiatan',
            event_description: 'Deskripsi',
            event_date: 'Tanggal Event',
            event_start: 'Tanggal Mulai',
            event_end: 'Tanggal Selesai',
            event_image_url: 'Gambar',
            event_link: 'Link Website',
        },
        banner: {
            judul: 'Judul',
            deskripsi: 'Deskripsi',
            tautan: 'Tautan',
            tipeTautan: 'Tipe Tautan',
            gambar: 'Gambar',
            status: 'Status',
        },
        sekolah: {
            namaSekolah: 'Nama Sekolah',
            email: 'Email',
            alamat: 'Alamat',
            namaAdmin: 'Nama Admin',
            status: 'Status',
            provinsi: 'Provinsi',
            kabupaten: 'Kota/Kabupaten',
            telepon: 'Telepon',
            logo: 'Logo Sekolah',
        },
        buku: {
            category: 'Kategori Buku',
            author: 'Penulis',
            digitalIsbn: 'ISBN Digital',
            physicalIsbn: 'ISBN Fisik',
            usingDrm: 'DRM',
            url: 'Tautan',
            bookTitle: 'Judul Buku',
            synopsis: 'Sinopsis',
            body: 'Isi Buku',
            status: 'Status',
            createdAt: 'Waktu Dibuat',
            file: 'File Buku',
            cover: 'Sampul Buku',
            totalPages: 'Jumlah Halaman',
            epustaka: 'EPustaka',
            fileExtension: 'Ekstensi File',
        },
        author: {
            author_name: 'Nama Penulis',
            author_phone: 'Telepon',
            author_email: 'Email Penulis',
            author_address: 'Alamat Penulis',
            category_id: 'Kategori',
        },
        multimediaCategory: {
            category_name: 'Nama Kategori',
            category_description: 'Deskripsi Kategori',
            is_active: 'Status',
        },
        video: {
            judul: 'Judul',
            category: 'Kategori',
            media_description: 'Deskripsi',
            media_thumbnail_url: 'Thumbnail',
            media_file_url: 'File',
            media_duration: 'Durasi',
        },
        epustaka: {
            epustaka_name: 'Nama Epustaka',
            epustaka_phone: 'Telepon',
            epustaka_email: 'Email Epustaka',
            epustaka_category: 'Kategori Epustaka',
            epustaka_address: 'Alamat Epustaka',
            epustaka_aboutus: 'Tentang Epustaka',
            epustaka_isactive: 'Status',
            epustaka_isprivate: 'Tipe',
            epustaka_logo: 'Logo',
        },
        teacherAssignment: {
            assignmentName: 'Nama Tugas',
            assignmentDescription: 'Deskripsi Tugas',
            assignmentDueDate: 'Tenggat Waktu',
            assignmentMaterial: 'Materi Tugas',
        },
        profile: {
            profileUser: 'Profil Pengguna',
            profileSchool: 'Profil Sekolah',
            editProfile: 'Ubah Profil Pengguna',
            editProfileSchool: 'Ubah Profil Sekolah',
        },
        question: {
            question: 'Soal',
            questionDetail: 'Detail Soal',
            competence: 'Kompetensi',
            questionSource: 'Sumber Soal',
            createdBy: 'Dibuat oleh',
            publish: 'Publish',
        },
        questionLevel: {
            levelName: 'Level',
            levelDescription: 'Deskripsi',
            levelWeight: 'Bobot Level',
        },
        questionScope: {
            scopeName: 'Cakupan',
            subScopeName: 'Jenis Cakupan',
        },
        subScope: {
            school: 'Sekolah',
            province: 'Provinsi',
            regency: 'Kabupaten',
            national: 'Nasional',
        },
        answer: {
            answer: 'Jawaban untuk',
            answerDetail: 'Jawaban',
            answerKey: 'Kunci Jawaban',
        },
        quizCategories: {
            category_name: 'Nama Kategori',
        },
        quiz: {
            quizDetail: 'Detail Kuis',
            quizCode: 'Kode Kuis',
            quizStart: 'Waktu Mulai',
            quizEnd: 'Waktu Selesai',
            quizTitle: 'Judul Kuis',
            quizDuration: 'Durasi Kuis',
            numberOfQuestions: 'Jumlah Soal',
            quizCreatedBy: 'Dibuat oleh',
            isActive: 'Diterbitkan?',
            times: 'Waktu',
        },
        donation: {
            idTransaction: 'ID Transaksi',
            donationDate: 'Tanggal',
            donationExiredDate: 'Tanggal Kadaluarsa',
            totalPay: 'Total Bayar',
            status: 'Status',
            paymentMethod: 'Metode Pembayaran',
            donationBy: 'Didonasikan oleh',
            donationTo: 'Didonasikan ke',

            jenis: 'Jenis',
            judul: 'Judul',
            cover: 'Cover',
            penulis: 'Penulis',
            tahunTerbit: 'Tahun Terbit',
        },
    },
    filter: {
        ganjil: 'Ganjil',
        genap: 'Genap',
    },
    status: {
        active: 'Aktif',
        nonActive: 'Tidak Aktif',
        inReview: 'Sedang Diulas',
        disabled: 'Tidak Aktif',
    },
}

export default lang
